import React from "react";

import Tag from "antd/es/tag";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import EmailDraftRecipientMetadata from "@mapmycustomers/shared/types/draft/EmailDraftRecipientMetadata";
import {
  EntitiesSupportedByEmailFeature,
  EntityTypesSupportedByEmailFeature,
} from "@mapmycustomers/shared/types/entity";

import EmailEntityOpenCallback from "@app/types/email/EmailEntityOpenCallback";

import styles from "./DraftRecipientsView.module.scss";
import messages from "./messages";

interface DraftRecipientsViewProps {
  entities: EntitiesSupportedByEmailFeature[];
  entityType: EntityTypesSupportedByEmailFeature;
  onEntityOpen: EmailEntityOpenCallback;
  recipients: EmailDraftRecipientMetadata[];
}

const DraftRecipientsView = ({
  entities,
  entityType,
  onEntityOpen,
  recipients,
}: DraftRecipientsViewProps) => {
  const intl = useIntl();
  return (
    <>
      {recipients.map((recipient, index) => {
        const entity = entities.find((entity) => entity.id === recipient.id);
        const clickable = !!entity;
        return (
          <React.Fragment key={index}>
            {!!index && ", "}
            <Tooltip
              title={clickable ? intl.formatMessage(messages.clickToOpenTooltip) : undefined}
            >
              <span
                className={cn(
                  styles.recipient,
                  { [styles.invalid]: !entity?.email },
                  { [styles.clickable]: clickable }
                )}
                onClick={entity ? () => onEntityOpen(entity!.id, entityType) : undefined}
              >
                <span className={cn(styles.recipientName)}>{recipient.name}</span>
                {entity && !entity.email && (
                  <Tag color="error">{intl.formatMessage(messages.emailNotFound)}</Tag>
                )}
                {!entity && <Tag color="error">{intl.formatMessage(messages.recordNotFound)}</Tag>}
              </span>
            </Tooltip>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default DraftRecipientsView;
